module.exports = __webpack_public_path__ + "img/main-logo.92dd4e67.png";